import React from 'react';
import PropTypes from 'prop-types';
import CircularProgress from '@material-ui/core/CircularProgress';


import Theme from "theme/main.theme.js";


class Loader extends React.Component{
    constructor(props) {
        super(props);
        this.state={
        };
    }
    
    static propTypes={
    };

    render(){
        return (
        <div style={{
          width:"100%",
          height:"100%",
          display:"flex",
          justifyContent:"center",
          alignItems:"center",
        }}>
          <div style={{
            color:Theme.color1,
          }}>
            <CircularProgress />
          </div>
        </div>
        );
    }
}


export {Loader};